import RouteBuilder from 'features/route-builder/RouteBuilder';

const RouteBuilderPage = () => <RouteBuilder />;

export default RouteBuilderPage;
